import { SessionActorType } from "@bcasmart/doxecure-commons/doxecureTypes";

import { Dashboard } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";

export const SignedDocumentsView = () => {
    const { connectedProfileId } = useAuthContext();
    optlog(`+++ SignedDocumentsView initialized with profile ID '${connectedProfileId}'`) ;

    return okOrError(
        connectedProfileId,
        (<Dashboard 
            title="Documents Signés"
            emptyMessage="Pas de documents signés"
            category="signed"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor, SessionActorType.Approver, SessionActorType.Signer]} 
            sectionInfos={defaultSectionInformations} 
        />),
        false,
        "Impossible d'afficher la liste des documents signés car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;    
};
